<template>
    <section id="fundation" class="pillars">

        <div class="pillars__container">

            <div class="pillars__header">

                <h2 class="section-title">
                    <span class="heading-line">
                        {{ 'pillars_content' | staticTitle }}
                    </span>
                </h2>

                <p class="section-description">
                    <vue-marked>{{ 'pillars_content' | staticContent }}</vue-marked>
                </p>

            </div>

            <div class="pillars__grid">

                <article class="pillar-card">

                    <div class="pillar-card__image">

                        <img
                            :src="'Bridgerocksworld.com_img19.webp' | assetsImg"
                            alt="Bridgerocks"
                        >

                        <div class="pillar-card__overlay"></div>

                    </div>

                    <div class="pillar-card__content">

                        <vue-marked>
                            {{ 'pillar_brdigerocks_corp' | staticContent }}
                        </vue-marked>

                        <a
                            :href="'site_br_bridgerocks' | cr"
                            class="pillar-card__button"
                        >
                            {{ 'Explore Corporate Services' | i18n }}

                            <i class="fa-solid fa-arrow-right"></i>
                        </a>

                    </div>

                </article>

                <article class="pillar-card">

                    <div class="pillar-card__image">

                        <img
                            :src="'Bridgerocksworld.com_img21.webp' | assetsImg"
                            alt="Reyrock"
                        >

                        <div class="pillar-card__overlay"></div>

                    </div>

                    <div class="pillar-card__content">

                        <vue-marked>
                            {{ 'pillar_reyrock' | staticContent }}
                        </vue-marked>

                        <a
                            :href="'site_br_reyrock_landing' | cr"
                            class="pillar-card__button"
                        >
                            {{ 'Explore the Opportunity Portfolio' | i18n }}

                            <i class="fa-solid fa-arrow-right"></i>
                        </a>

                    </div>

                </article>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: "HomePillars"
};
</script>

<style lang="scss">
.pillars {

    .pillar-card__button {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        gap: 18px;
        min-width: 245px;
        min-height: 48px;
        padding: 0 20px;
        border: 1px solid #D2AB5B;
        border-radius: 6px;
        color: #FFFFFF;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: .3px;
        line-height: 1.2;
        text-decoration: none;
        transition: .3s;

        i {
            font-size: 12px;
            color: #D2AB5B;
            transition: transform .3s;
        }

        &:hover {
            background: #D2AB5B;
            color: #0F1824;

            i {
                color: #0F1824;
                transform: translateX(4px);
            }
        }
    }

    @media (max-width: 768px) {

        .pillar-card__button {
            width: 100%;
            min-width: 0;
            min-height: 46px;
            padding: 0 16px;
            font-size: 13px;
        }

    }

}
</style>